import { type CustomWorkflowRunFormField, type CustomWorkflowRunInputValue } from '../../store/customWorkflow/customWorkflows'

const OUTPUT_VAR_SPLIT_REGEX = /(\{\{#\$output\.[^#]+#\}\})/g
const OUTPUT_VAR_NAME_REGEX = /^\{\{#\$output\.([^#]+)#\}\}$/
const OUTPUT_VAR_MATCH_ALL_REGEX = /\{\{#\$output\.([^#]+)#\}\}/g

export const splitByOutputVar = (content: string): string[] => content.split(OUTPUT_VAR_SPLIT_REGEX).filter((part) => part.length > 0)

export const extractOutputVarName = (segment: string): string | null => OUTPUT_VAR_NAME_REGEX.exec(segment)?.[1] ?? null

export const getFormContentInputNames = (content: string): string[] => [...content.matchAll(OUTPUT_VAR_MATCH_ALL_REGEX)].map((match) => match[1])

export const hasInvalidSelectOrFileInput = (fields: CustomWorkflowRunFormField[], values: Record<string, CustomWorkflowRunInputValue>): boolean =>
  fields.some((field) => {
    const value = values[field.variable]
    if (field.type === 'select') {
      return typeof value !== 'string' || value.length === 0
    }
    if (field.type === 'checkbox-list') {
      return !Array.isArray(value) || value.some((item) => typeof item !== 'string')
    }
    if (field.type === 'file') {
      return !value || typeof value !== 'object' || Array.isArray(value)
    }
    if (field.type === 'file-list') {
      return !Array.isArray(value) || value.length === 0
    }
    return false
  })
